var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NavBarSearch"},[_c('span',{staticClass:"NavBarSearch__element"},[_c('span',{staticClass:"NavBarSearch__title"},[_vm._v("\n      Search results for \""+_vm._s(_vm.searchString)+"\"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }